// extracted by mini-css-extract-plugin
export default {"wrapper":"CreationDisplayArea_wrapper__LPqFN"};